module.exports = __webpack_public_path__ + "img/projects.c9df4e2a.svg";